import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { JobCreateData, JobExecutorData } from '@mews-commander/data-access';
import { createAction, lt, showSuccessAlert } from '@mews/framework';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { RouteName } from '@mews-commander/enums';
import { navigateInBaseModal } from '../app/actions/common';
import { JobFormValues } from './types';

const JOBS_CREATED = 'JobsCreated';

export const submitJobExecutionForm =
    (values: JobFormValues, jobExecutors: Array<JobExecutorData>): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories, appClockService, resolveRoute }) => {
        const { teams, ...teamExecutorNames } = values;
        const startUtc = appClockService.getAppNowUtc().value;

        const executorData = pipe(
            teams,
            array.flatMap((team) => teamExecutorNames[team]),
            array.filterMap((executorName) =>
                array.findFirst((executor: JobExecutorData) => executor.name === executorName)(jobExecutors)
            ),
            array.flatMap((executor) =>
                executor.defaultParameters.map(
                    (params): JobCreateData => ({
                        ...params,
                        startUtc,
                        executorTypeName: executor.name,
                    })
                )
            )
        );

        const promise = repositories.jobs.create({ jobs: executorData }).then(() => {
            const url = resolveRoute(RouteName.JobIndex);
            dispatch(navigateInBaseModal(url));
            showSuccessAlert({ description: lt('Success') });
        });

        return dispatch(createAction(JOBS_CREATED, promise));
    };
